import { userService } from '@saucelabs/sl-util-axios';

export const getUser = (id) => (
  userService.get(`/v1/users/${id}/`)
);

export const getAccessKey = (id) => (
  userService.get(`/v1/users/${id}/access-key/`)
);

export const sendResetPasswordEmail = (id) => (
  userService.post(`/v1/users/${id}/reset-password/`)
);
